import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import RatePlanTable from './components/rateplanTable';
import SectionHeading from '../sectionHeading';

const RatePlans = ({
  hardware,
  orderType,
  productSelected,
  rateplanList,
  contentfulError,
  accountType,
  corporateType,
  viewType,
  ratePlans,
  setRatePlans,
  total,
  setTotal,
  formErrors,
  setRatePlanError,
  setGeoTabNewPriceValid,
  setHardware
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: { valuePowerFleet, valueGeotab },
    iotOrderDetailsSection: { ratePlanHeading, ratePlanHeadingGeotab }
  } = localizedStrings;
  const errorMessage = _.get(formErrors, 'iotRatePlans.text', '');

  useEffect(() => {
    if (_.isEmpty(ratePlans)) {
      const initialRateplanObject = rateplanList.reduce((planAcc, planData) => {
        const {
          rateplanName,
          rateplanType,
          isHeader,
          deviceList,
          showRateplanInSummary
        } = _.get(planData, 'fields', {});
        if (!isHeader) {
          const deviceListObject = deviceList.reduce(
            (deviceAcc, deviceData) => {
              const { deviceName } = _.get(deviceData, 'fields', {});

              return {
                ...deviceAcc,
                [deviceName]: {
                  term: '',
                  quantity: 0,
                  unitPrice: 0,
                  fiftyPercentInUS: false,
                  rateplanType,
                  showRateplanInSummary: !!showRateplanInSummary
                }
              };
            },
            {}
          );
          return {
            ...planAcc,
            [rateplanName]: {
              ...deviceListObject
            }
          };
        }

        return planAcc;
      }, {});
      setRatePlans(initialRateplanObject);
    }
  }, []);
  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          <Typography>Error fetching rateplans data from contentful</Typography>
        </Notification>
      )}
      {!contentfulError && rateplanList.length > 0 && (
        <StackView space={3}>
          <SectionHeading>
            <Typography heading="h4" variant={{ size: 'h4' }} block>
              {(() => {
                if (productSelected === valuePowerFleet) return 'Monthly Subscription';
                if (productSelected === valueGeotab) return ratePlanHeadingGeotab;
                return ratePlanHeading;
              })()}
            </Typography>
          </SectionHeading>
          <RatePlanTable
            hardware={hardware}
            orderType={orderType}
            productSelected={productSelected}
            accountType={accountType}
            corporateType={corporateType}
            viewType={viewType}
            ratePlans={ratePlans}
            setRatePlans={setRatePlans}
            rateplanList={rateplanList}
            total={total}
            setTotal={setTotal}
            setRatePlanError={setRatePlanError}
            setGeoTabNewPriceValid={setGeoTabNewPriceValid}
            setHardware={setHardware}
          />
          <Divider space={3} variant={{ inverse: true }} />
        </StackView>
      )}
      {errorMessage && (
        <Notification variant={{ validation: 'error' }}>
          <Typography>{errorMessage}</Typography>
        </Notification>
      )}
    </>
  );
};

RatePlans.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  rateplanList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.PropTypes.shape({}).isRequired,
  accountType: PropTypes.string.isRequired,
  corporateType: PropTypes.string,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.PropTypes.shape({}).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({}).isRequired,
  setRatePlanError: PropTypes.func.isRequired
};

export default RatePlans;
